var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../LayoutDesigner/LayoutDesigner", "../LayoutDesigner/LayoutElement", "../Components/NumericInputComponent", "../EventEmitter", "../Models/Content/ViewPort", "../Models/Content/Layer", "../Models/Content/MultiScreen", "../Shared/Helper", "../../lib/interactjs/dist/interact", "../Models/Format", "vue", "../Shared/NovoNoty", "decimal.js-light"], function (require, exports, LayoutDesigner_1, LayoutElement_1, NumericInputComponent_1, EventEmitter_1, ViewPort_1, Layer_1, MultiScreen_1, Helper_1, interact, Format_1, vue_1, NovoNoty_1, decimal_js_light_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LayoutDesignController = (function (_super) {
        __extends(LayoutDesignController, _super);
        function LayoutDesignController(multiScreenId, assignedTenant, assignedLocation) {
            var _this = _super.call(this) || this;
            _this.layoutTemplate = '<div><div class="kachel"><div class="layout-element"><div class="TvScreenRect"></div></div><hr class="cyb-hr"/><div><span class="main-line">XXXParser</span><br/><span class="sub-line">YYYParser</span></div></div><div></div>';
            _this.currentMultiScreenId = "";
            _this.assignedTenantId = "";
            _this.debug = true;
            _this.currentMultiScreenId = multiScreenId;
            _this.assignedTenantId = assignedTenant;
            _this.assignedLocationId = assignedLocation;
            var host = _this;
            $(window).on('OnResizeEnd', function () {
                host.SetWorkspaceSize();
                host.layoutDesigner.RecalculateElementsTransform();
            });
            var nic = new NumericInputComponent_1.NumericInputComponent();
            _this.canvas = $("#virtualScreenCanvas");
            _this.root = $("#virtualScreenWorkSpace");
            host.formatLayoutDesigner = new LayoutDesigner_1.LayoutDesigner(_this.root, "fm");
            host.formatLayoutDesigner.elementClassName = "col-xs-6 col-sm-6 col-md-12 col-lg-6 col-xl-6 col-xxl-4";
            host.layoutDesigner = new LayoutDesigner_1.LayoutDesigner(_this.root, "vs");
            host.layoutDesigner.elementClassName = "ViewRect WhiteInsetShadow Dragable";
            host.layoutDesigner.elementSelectedClassName = "SelectedViewRect WhiteInsetShadow Dragable";
            host.layoutDesigner.AddEventListener(LayoutElement_1.LayoutElement.OnElementDropped, host.ElementDropped.bind(host));
            host.layoutDesigner.AddEventListener(LayoutElement_1.LayoutElement.OnElementTouched, host.ElementTouched.bind(host));
            host.layoutDesigner.ApplyDropzone("#virtualScreenWorkSpace", ".Dragable");
            host.AddEventListener("MovedOverElement", host.CreateNewElement.bind(host));
            host.CreateViewPortFormats($("#viewPortFormatContent"), host.layoutTemplate);
            host.remoteDataSource = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: "/api/v1/contents/" + _this.currentMultiScreenId,
                        type: "get", dataType: "json"
                    },
                    create: {
                        url: "/api/v1/contents",
                        type: "post", dataType: "json", contentType: "application/json"
                    },
                    update: {
                        url: "/api/v1/contents",
                        type: "put", dataType: "json", contentType: "application/json"
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== "read" && data) {
                            return kendo.stringify(data);
                        }
                    }
                },
                schema: {
                    type: "json",
                    model: {
                        id: "Id",
                        fields: { Id: "Id" }
                    }
                },
                change: function (e) {
                    if (this.debug) {
                        console.log("change");
                        console.log(e.items[0]);
                    }
                },
                requestEnd: function (e) {
                    if (e.type === undefined)
                        return;
                    if (this.debug) {
                        console.log("requestEnd");
                        console.log(e);
                    }
                    var response = e.response;
                    var type = e.type;
                    if (type === "read") {
                        host.CreateLayout(response);
                        host.SetGuiValues(response);
                    }
                    else {
                        if (e.response != undefined)
                            NovoNoty_1.NovoNoty.Show("Der Befehl wurde erfolgreich ausgeführt.");
                    }
                },
                error: function (e) {
                    if (this.debug) {
                        console.log("RemoteDataSource Error");
                        console.log(e.status);
                    }
                    NovoNoty_1.NovoNoty.ShowErrorDetails(e);
                }
            });
            host.headVm = new vue_1.default({
                el: '#layoutDesignerHeadUI',
                data: {
                    name: "",
                    currentLayer: 0,
                    SecurityInfoLevel: 8
                },
                computed: {
                    accessibleByUser: {
                        get: function () {
                            return this.SecurityInfoLevel === 4;
                        },
                        set: function (newValue) {
                            if (newValue)
                                this.SecurityInfoLevel = 4;
                            else
                                this.SecurityInfoLevel = 8;
                        }
                    }
                },
                methods: {
                    SetLayer1: function (event) {
                        host.headVm.currentLayer = 0;
                        host.layoutDesigner.SetActiveLayer(0);
                        host.layoutDesigner.ApplyAllInteractionsToAllElements();
                    },
                    SetLayer2: function (event) {
                        host.headVm.currentLayer = 1;
                        host.layoutDesigner.SetActiveLayer(1);
                        host.layoutDesigner.ApplyAllInteractionsToAllElements();
                    }
                }
            });
            host.rootVm = new vue_1.default({
                el: '#layoutDesignerUI',
                data: {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                    ratioWidth: 0,
                    ratioHeight: 0,
                    preserveAspectRatio: false,
                    workspaceFormatX: 0,
                    workspaceFormatY: 0
                },
                computed: {
                    AspectRatio: function () {
                        return new decimal_js_light_1.Decimal(this.ratioWidth).dividedBy(this.ratioHeight);
                    }
                },
                methods: {
                    Save: function (event) {
                        host.Save();
                    },
                    CreateLayoutElement: function (event) {
                        if (this.debug)
                            console.log("CreateLayoutElement");
                        var layoutElement = host.layoutDesigner.CreateLayoutElement();
                        host.layoutDesigner.ApplyAllInteractionsToAllElements();
                    },
                    DeleteLayoutElement: function (event) {
                        if (this.debug)
                            console.log("DeleteLayoutElement");
                        if (host.layoutDesigner.SelectedElement == null) {
                            NovoNoty_1.NovoNoty.ShowError("Bitte selektieren Sie zuerst ein Template-Element");
                            return;
                        }
                        host.layoutDesigner.DeleteSelectedLayoutElement();
                        host.layoutDesigner.ApplyAllInteractionsToAllElements();
                    },
                    UpdateX: function (childVm, value) {
                        if (host.layoutDesigner.SelectedElement == null) {
                            NovoNoty_1.NovoNoty.ShowError("Bitte selektieren Sie zuerst ein Template-Element");
                            return;
                        }
                        if (value == null || value == "" || value < 0)
                            value = 0;
                        if (value > 100)
                            value = 100;
                        value /= 100;
                        if (this.debug)
                            console.log("UpdateX: " + value);
                        host.layoutDesigner.SelectedElement.SetPercentX(value);
                        host.ValidateElementTransform(host.layoutDesigner.SelectedElement);
                        host.SetGuiMeasurementValues(host.layoutDesigner.SelectedElement);
                        host.layoutDesigner.ApplyAllInteractionsToAllElements();
                    },
                    UpdateY: function (childVm, value) {
                        if (host.layoutDesigner.SelectedElement == null) {
                            NovoNoty_1.NovoNoty.ShowError("Bitte selektieren Sie zuerst ein Template-Element");
                            return;
                        }
                        if (value == null || value == "" || value < 0)
                            value = 0;
                        if (value > 100)
                            value = 100;
                        value /= 100;
                        if (this.debug)
                            console.log("UpdateY: " + value);
                        host.layoutDesigner.SelectedElement.SetPercentY(value);
                        host.ValidateElementTransform(host.layoutDesigner.SelectedElement);
                        host.SetGuiMeasurementValues(host.layoutDesigner.SelectedElement);
                        host.layoutDesigner.ApplyAllInteractionsToAllElements();
                    },
                    UpdateWidth: function (childVm, value) {
                        if (host.layoutDesigner.SelectedElement == null) {
                            NovoNoty_1.NovoNoty.ShowError("Bitte selektieren Sie zuerst ein Template-Element");
                            return;
                        }
                        if (value == null || value == "" || value < 0)
                            value = 0;
                        var dWidth = new decimal_js_light_1.Decimal(value).dividedBy(100);
                        if (this.debug)
                            console.log("UpdateWidth: " + dWidth.toPrecision(5));
                        host.layoutDesigner.SelectedElement.SetPercentWidth(dWidth);
                        if (this.preserveAspectRatio) {
                            host.layoutDesigner.SelectedElement.SetHeightByAspectRatio(this.AspectRatio);
                        }
                        host.ValidateElementSize(host.layoutDesigner.SelectedElement);
                        host.SetGuiMeasurementValues(host.layoutDesigner.SelectedElement);
                        host.layoutDesigner.ApplyAllInteractionsToAllElements();
                    },
                    UpdateHeight: function (childVm, value) {
                        if (host.layoutDesigner.SelectedElement == null) {
                            NovoNoty_1.NovoNoty.ShowError("Bitte selektieren Sie zuerst ein Template-Element");
                            return;
                        }
                        if (value == null || value == "" || value < 0)
                            value = 0;
                        var dHeight = new decimal_js_light_1.Decimal(value).dividedBy(100);
                        if (this.debug)
                            console.log("UpdateHeight: " + dHeight);
                        host.layoutDesigner.SelectedElement.SetPercentHeight(dHeight);
                        if (this.preserveAspectRatio) {
                            var invertedAspectRatio = new decimal_js_light_1.Decimal(1).div(this.AspectRatio);
                            host.layoutDesigner.SelectedElement.SetWidthByAspectRatio(invertedAspectRatio);
                        }
                        host.ValidateElementTransform(host.layoutDesigner.SelectedElement);
                        host.SetGuiMeasurementValues(host.layoutDesigner.SelectedElement);
                        host.layoutDesigner.ApplyAllInteractionsToAllElements();
                    },
                    UpdateRatioWidth: function (childVm, value) {
                        if (host.layoutDesigner.SelectedElement == null) {
                            NovoNoty_1.NovoNoty.ShowError("Bitte selektieren Sie zuerst ein Template-Element");
                            return;
                        }
                        if (value == null || value == "" || value < 0)
                            value = 1;
                        this.ratioWidth = parseFloat(value);
                        if (this.preserveAspectRatio) {
                            host.layoutDesigner.SelectedElement.SetHeightByAspectRatio(this.AspectRatio);
                            this.height = host.layoutDesigner.SelectedElement.CalculatePercentHeight().toNumber();
                            host.SetCurrentFormatToElement(host.layoutDesigner.SelectedElement);
                            host.ValidateElementTransform(host.layoutDesigner.SelectedElement);
                            host.SetGuiMeasurementValues(host.layoutDesigner.SelectedElement);
                            host.layoutDesigner.ApplyAllInteractionsToAllElements();
                        }
                        host.ApplyRatioValuesToLayoutDesigner();
                    },
                    UpdateRatioHeight: function (childVm, value) {
                        if (host.layoutDesigner.SelectedElement == null) {
                            NovoNoty_1.NovoNoty.ShowError("Bitte selektieren Sie zuerst ein Template-Element");
                            return;
                        }
                        if (value == null || value == "" || value < 0)
                            value = 1;
                        this.ratioHeight = parseFloat(value);
                        if (this.preserveAspectRatio) {
                            host.layoutDesigner.SelectedElement.SetHeightByAspectRatio(this.AspectRatio);
                            this.height = host.layoutDesigner.SelectedElement.CalculatePercentHeight().toNumber();
                            host.SetCurrentFormatToElement(host.layoutDesigner.SelectedElement);
                            host.ValidateElementTransform(host.layoutDesigner.SelectedElement);
                            host.SetGuiMeasurementValues(host.layoutDesigner.SelectedElement);
                            host.layoutDesigner.ApplyAllInteractionsToAllElements();
                        }
                        host.ApplyRatioValuesToLayoutDesigner();
                    },
                    UpdatePreserveAspectRatio: function (event) {
                        host.ApplyRatioValuesToLayoutDesigner();
                    },
                    UpdateWorkspaceFormatX: function (childVm, value) {
                        if (value == null || value == "" || value < 1)
                            value = 1;
                        this.workspaceFormatX = value;
                        host.SetWorkspaceSize();
                        host.layoutDesigner.RecalculateElementsTransform();
                    },
                    UpdateWorkspaceFormatY: function (childVm, value) {
                        if (value == null || value == "" || value < 1)
                            value = 1;
                        this.workspaceFormatY = value;
                        host.SetWorkspaceSize();
                        host.layoutDesigner.RecalculateElementsTransform();
                    }
                }
            });
            host.rootVm.workspaceFormatX = 16;
            host.rootVm.workspaceFormatY = 9;
            _this.SetWorkspaceSize();
            host.SetGuiRatioValues(1, 1);
            host.rootVm.preserveAspectRatio = true;
            if (host.currentMultiScreenId != "new")
                host.Load();
            return _this;
        }
        LayoutDesignController.prototype.SetGuiRatioValues = function (w, h) {
            this.rootVm.ratioWidth = w;
            this.rootVm.ratioHeight = h;
        };
        LayoutDesignController.prototype.ApplyRatioValuesToLayoutDesigner = function () {
            this.layoutDesigner.SetAspectRatio(this.rootVm.AspectRatio.toNumber(), this.rootVm.preserveAspectRatio);
        };
        LayoutDesignController.prototype.SetCurrentFormatToElement = function (element) {
            var newFormat = new Format_1.Format();
            newFormat.width = this.rootVm.ratioWidth;
            newFormat.height = this.rootVm.ratioHeight;
            element.object = newFormat;
        };
        LayoutDesignController.prototype.ValidateElementPosition = function (element) {
            if (element.x < 0)
                element.SetPosition(0, element.y);
            if (element.y < 0)
                element.SetPosition(element.x, 0);
        };
        LayoutDesignController.prototype.ValidateElementTransform = function (element) {
            this.ValidateElementPosition(element);
            this.ValidateElementSize(element);
        };
        LayoutDesignController.prototype.ValidateElementSize = function (element) {
            this.ValidateElementPosition(element);
            var maxPercentWidth = 1 - element.pX;
            if (element.pWidth.toNumber() > maxPercentWidth) {
                element.SetPercentWidth(new decimal_js_light_1.Decimal(maxPercentWidth));
                if (this.rootVm.preserveAspectRatio)
                    element.SetHeightByAspectRatio(this.rootVm.AspectRatio);
            }
            var maxPercentHeight = 1 - element.pY;
            if (element.pHeight.toNumber() > maxPercentHeight) {
                element.SetPercentHeight(new decimal_js_light_1.Decimal(maxPercentHeight));
                if (this.rootVm.preserveAspectRatio) {
                    if (this.rootVm.AspectRatio.toNumber() < 1) {
                        var invertedAspectRatio = new decimal_js_light_1.Decimal(1).div(this.rootVm.AspectRatio);
                        element.SetWidthByAspectRatio(invertedAspectRatio);
                    }
                    else {
                        element.SetWidthByAspectRatio(this.rootVm.AspectRatio);
                    }
                }
            }
        };
        LayoutDesignController.prototype.CreateViewPortFormats = function (parentContent, layoutTemplate) {
            console.log("CreateViewPortFormats");
            var maxIconWidth = 70;
            var maxIconHeight = 55;
            var formats = new Array();
            var format = new Format_1.Format();
            format.width = 1;
            format.height = 1;
            formats.push(format);
            format = new Format_1.Format();
            format.width = 2;
            format.height = 1;
            formats.push(format);
            format = new Format_1.Format();
            format.width = 16;
            format.height = 9;
            formats.push(format);
            format = new Format_1.Format();
            format.width = 16;
            format.height = 10;
            formats.push(format);
            format = new Format_1.Format();
            format.width = 4;
            format.height = 3;
            formats.push(format);
            format = new Format_1.Format();
            format.width = 1;
            format.height = 2;
            formats.push(format);
            format = new Format_1.Format();
            format.width = 9;
            format.height = 16;
            formats.push(format);
            format = new Format_1.Format();
            format.width = 10;
            format.height = 16;
            formats.push(format);
            format = new Format_1.Format();
            format.width = 3;
            format.height = 4;
            formats.push(format);
            for (var _i = 0, formats_1 = formats; _i < formats_1.length; _i++) {
                var format_1 = formats_1[_i];
                var ratio = format_1.width / format_1.height;
                var layoutElement = this.formatLayoutDesigner.CreateLayoutElement(0, 0, 0, 0, parentContent, layoutTemplate, true);
                layoutElement.object = format_1;
                var elementText = format_1.width + ":" + format_1.height;
                layoutElement.SetTextContent(elementText, ".main-line");
                layoutElement.SetTextContent("", ".sub-line");
                if (format_1.width > format_1.height)
                    layoutElement.GetSubElement(".TvScreenRect").width(maxIconWidth).height(maxIconWidth / ratio);
                else
                    layoutElement.GetSubElement(".TvScreenRect").height(maxIconHeight).width(maxIconHeight * ratio);
                layoutElement.AddOnMoveEvent(this);
            }
        };
        LayoutDesignController.prototype.SetWorkspaceSize = function () {
            var cWidth = this.canvas.width();
            var cHeight = this.canvas.height();
            var canvasRatio = cWidth / cHeight;
            var workSpaceRatio = this.rootVm.workspaceFormatX / this.rootVm.workspaceFormatY;
            if (canvasRatio < workSpaceRatio) {
                this.root.width(cWidth);
                this.root.height(cWidth / workSpaceRatio);
            }
            else {
                this.root.height(cHeight);
                this.root.width(cHeight * workSpaceRatio);
            }
        };
        LayoutDesignController.prototype.CreateNewElement = function (sender, data) {
            var event = data.event;
            var tvLayoutElement = data.layoutElement;
            var format = tvLayoutElement.object;
            var ratio = format.width / format.height;
            var layoutElement = this.layoutDesigner.CreateLayoutElement(100, 100 / ratio, 0, 0, this.root);
            layoutElement.object = format;
            this.layoutDesigner.ApplyAllInteractionsToAllElements();
            var clientRect = tvLayoutElement.GetRect();
            var rootRect = interact("#virtualScreenWorkSpace").getRect();
            layoutElement.ScaleSize(1.5);
            var posX = event.pageX - rootRect.left - (layoutElement.width.toNumber() / 2);
            var posY = event.pageY - rootRect.top - (layoutElement.height.toNumber() / 2);
            layoutElement.SetPosition(posX, posY);
            layoutElement.StartInteraction("drag", data.event.interaction);
        };
        LayoutDesignController.prototype.GetData = function () {
            var elements = this.layoutDesigner.GetElements();
            var viewPorts = [];
            var multiScreen = new MultiScreen_1.MultiScreen();
            for (var layer = 0; layer < 2; layer++) {
                viewPorts = [];
                for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
                    var e = elements_1[_i];
                    var viewPort = new ViewPort_1.ViewPort();
                    viewPort.PercentW = Helper_1.Helper.Round(e.pWidth.toNumber(), 5);
                    viewPort.PercentH = Helper_1.Helper.Round(e.pHeight.toNumber(), 5);
                    viewPort.PercentX = Helper_1.Helper.Round(e.pX, 5);
                    viewPort.PercentY = Helper_1.Helper.Round(e.pY, 5);
                    if (e.LayerIndex == layer)
                        viewPorts.push(viewPort);
                }
                if (viewPorts.length > 0) {
                    multiScreen.Layers[layer] = new Layer_1.Layer();
                    multiScreen.Layers[layer].zIndex = layer;
                    multiScreen.Layers[layer].ViewPorts = viewPorts;
                }
            }
            multiScreen.Name = this.headVm.name;
            multiScreen.TenantId = this.assignedTenantId;
            multiScreen.SecurityInfo.Level = this.headVm.SecurityInfoLevel;
            if (window["CanAccessAllLocations"] == true)
                multiScreen.AssignedLocations = ["all"];
            else
                multiScreen.AssignedLocations = this.assignedLocationId;
            return multiScreen;
        };
        LayoutDesignController.prototype.Save = function () {
            if (this.headVm.name == null || this.headVm.name == "" || this.headVm.name == " ") {
                NovoNoty_1.NovoNoty.ShowError("Bitte geben Sie einen Namen ein.");
                return;
            }
            if (this.layoutDesigner.GetElements().length == 0) {
                NovoNoty_1.NovoNoty.ShowError("Fügen Sie mindestens ein Template-Element hinzu.");
                return;
            }
            var multiScreen = this.GetData();
            var data = this.remoteDataSource.data();
            if (data.length == 0) {
                this.remoteDataSource.add(multiScreen);
            }
            else {
                var myData = this.remoteDataSource.at(0);
                myData.Layers = multiScreen.Layers;
                myData.Name = multiScreen.Name;
                myData.TenantId = multiScreen.TenantId;
                myData.SecurityInfo = multiScreen.SecurityInfo;
                myData.dirty = true;
            }
            this.remoteDataSource.sync();
        };
        LayoutDesignController.prototype.Load = function () {
            this.remoteDataSource.read();
        };
        LayoutDesignController.prototype.CreateLayout = function (data) {
            this.layoutDesigner.ClearAllElements();
            var layers = data.Layers;
            for (var _i = 0, layers_1 = layers; _i < layers_1.length; _i++) {
                var layer = layers_1[_i];
                var viewPorts = layer.ViewPorts;
                for (var _a = 0, viewPorts_1 = viewPorts; _a < viewPorts_1.length; _a++) {
                    var vP = viewPorts_1[_a];
                    var element = this.layoutDesigner.CreateLayoutElementRelative(vP.PercentW, vP.PercentH, vP.PercentX, vP.PercentY);
                    if (layer.zIndex == undefined)
                        element.LayerIndex = 0;
                    else
                        element.LayerIndex = layer.zIndex;
                }
            }
            this.ApplyRatioValuesToLayoutDesigner();
            this.layoutDesigner.ApplyAllInteractionsToAllElements();
            this.layoutDesigner.SetActiveLayer(0);
        };
        LayoutDesignController.prototype.SetGuiValues = function (data) {
            var multiScreen = data;
            this.headVm.name = multiScreen.Name;
            this.headVm.SecurityInfoLevel = multiScreen.SecurityInfo.Level;
        };
        LayoutDesignController.prototype.SetGuiMeasurementValues = function (layoutElement) {
            this.rootVm.width = layoutElement.pWidth.mul(100).toPrecision(5);
            this.rootVm.height = layoutElement.pHeight.mul(100).toPrecision(5);
            this.rootVm.x = Helper_1.Helper.Round(layoutElement.pX * 100, 3);
            this.rootVm.y = Helper_1.Helper.Round(layoutElement.pY * 100, 3);
        };
        LayoutDesignController.prototype.ElementDropped = function (sender, data) {
            var layoutElement = data.layoutElement;
            var format = layoutElement.object;
            if (this.layoutDesigner.ElementIsInDropzone) {
                if (format != null)
                    this.SetGuiRatioValues(format.width, format.height);
                this.ValidateElementTransform(layoutElement);
                this.SetGuiMeasurementValues(layoutElement);
                this.ApplyRatioValuesToLayoutDesigner();
                this.layoutDesigner.ApplyAllInteractionsToAllElements();
            }
        };
        LayoutDesignController.prototype.ElementTouched = function (sender, data) {
            var layoutElement = data.layoutElement;
            var format = layoutElement.object;
            if (format != null)
                this.SetGuiRatioValues(format.width, format.height);
            this.SetGuiMeasurementValues(layoutElement);
        };
        return LayoutDesignController;
    }(EventEmitter_1.EventEmitter));
    $(function () {
        if ($("#layoutDesignerUI").length > 0) {
            var layoutDesignController = new LayoutDesignController(window["multiScreenId"], window["selectedTenant"], window["assignedLocation"]);
        }
    });
});
//# sourceMappingURL=LayoutDesignController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/LayoutDesignController.js
// module id = 369
// module chunks = 0